import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]


const __default__ = {};

interface ITabsBtnItem {
  key: string;
  title: string;
}

interface IProps {
  tabs: ITabsBtnItem[];
  activeTab: string;
  isShowBorder?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TabsBtn',
  props: {
    tabs: {},
    activeTab: { default: "" },
    isShowBorder: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;



const changeTag = (tag: string) => {
  emits("change", tag);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["as-nav-tabs-btn", {
      'as-nav-tabs-btn__border': _ctx.isShowBorder,
    }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tab.key,
        class: _normalizeClass(["as-nav-item", { active: _ctx.activeTab === tab.key }]),
        onClick: ($event: any) => (changeTag(tab.key))
      }, _toDisplayString(tab.title), 11, _hoisted_1))
    }), 128))
  ], 2))
}
}

})